<template>
  <div>
    <div id="Loader" v-if="LoadYn">
      <div class="spinner-bar">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <b-row
      class="jcfe"
      style="padding: 20px 20px 0px 20px; font-size: medium; color: #b4b7bd"
    >
      <span>상태 : {{ sensorstate }} ({{ statedescription }})</span>
    </b-row>
    <b-row class="h600 chartarea">
      <b-col class="col-6 pr10">
        <b-card
          class="h-100 default-border1"
          body-class="h-100 p-0"
          header-tag="header"
        >
          <h6 slot="header">3D Plot</h6>
          <div id="dataChart1" class="graph default-border-top1"></div>
        </b-card>
      </b-col>
      <b-col class="col-6 pl10">
        <b-row class="h180">
          <b-card
            class="w-100 h-100 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">위도</h6>
            <div id="dataChart2" class="graph default-border-top1"></div>
          </b-card>
        </b-row>
        <b-row class="h180 my10">
          <b-card
            class="w-100 h-100 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">경도</h6>
            <div id="dataChart3" class="graph default-border-top1"></div>
          </b-card>
        </b-row>
        <b-row class="h180">
          <b-card
            class="w-100 h-100 default-border1"
            body-class="h-100 p-0"
            header-tag="header"
          >
            <h6 slot="header">고도</h6>
            <div id="dataChart4" class="graph default-border-top1"></div>
          </b-card>
        </b-row>
      </b-col>
    </b-row>
    <div class="btnGrp">
      <div class="jcfe pr20">
        <b-button
          class="full-startBtn"
          @click="cmdRealtimeData('start')"
          :disabled="btnDisabled"
          ><i class="fas fa-play"></i>시작</b-button
        >
        <b-button
          class="full-stopBtn"
          @click="cmdRealtimeData('stop')"
          :disabled="!btnDisabled"
          ><i class="fas fa-pause"></i>중지</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import utils from "../common/utils";
import moment from "moment";
import chartUtil from "../common/chartUtil";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  computed: {
    ...mapGetters([
      "getAlertOptions",
      "getConfirmOptions",
      "getCenterBus",
      "getWebSocket",
    ]),
  },
  props: {
    defaultInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      LoadYn: false,
      btnDisabled: true,
      curTopicId: null,
      dataChartCnt: 30,
      sensorstate: null,
      statedescription: "",
      description: {
        0: "Fix not available or invalid",
        1: "Single point",
        2: "Pseudorange differential",
        4: "RTK fixed ambiguity solution",
        5: "RTK floating ambiguity solution",
        6: "Dead reckoning mode",
        7: "Manual input mode (fixed position)",
        8: "Simulator mode",
        9: "WAAS (SBAS)",
      },
      isFirst: true,
      count: 0,
    };
  },
  created() {},
  beforeMount() {},
  mounted() {
    window.addEventListener("beforeunload", this.reloadEvent);
    this.cmdRealtimeData("start");

    this.getCenterBus.$on("webSocketServerMessage", (param) => {
      if (param) {
        switch (param.target) {
          case "rabbitMQData":
            let data = JSON.parse(param.data);
            this.subRealtimeData(data);
            break;
          case "rabbitMQError":
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(param.data, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
            break;
        }
      }
    });
  },
  destroyed() {
    this.cmdRealtimeData("stop");
    window.removeEventListener("beforeunload", this.reloadEvent);
    this.getCenterBus.$off("webSocketServerMessage");
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    reloadEvent() {
      this.cmdRealtimeData("stop");
    },
    cmdRealtimeData(cmd) {
      if (cmd === "start") {
        this.LoadYn = true;
        this.setRealtimeData(cmd);
      } else {
        this.LoadYn = true;
        this.unSubRealtimeData();
        if (this.curTopicId) {
          this.setRealtimeData(cmd);
        }
      }
    },
    setRealtimeData(cmd) {
      var reqBody = {
        devid: this.defaultInfo.devid,
        devtype: this.defaultInfo.devtype,
        sensoridx: this.defaultInfo.sensoridx,
        command: cmd,
        mq_topic_id: cmd === "stop" ? this.curTopicId : null,
      };
      this.$http
        .post("/sensor/cmdRealtimeData", reqBody, { timeout: 50000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.LoadYn = false;
            if (cmd === "start") {
              var chartData = res.data.data;
              if (
                Object.keys(chartData).length !== 0 &&
                chartData.mq_topic_id !== undefined
              ) {
                this.btnDisabled = true;
                this.curTopicId = chartData.mq_topic_id;

                this.getWebSocket.send(
                  JSON.stringify({
                    target: "onRabbitMQData",
                    exchange: chartData.exchange,
                    topic: this.curTopicId,
                  })
                );
              } else {
                this.setAlertTitle();
                this.$bvModal
                  .msgBoxOk(
                    "해당 데이터가 존재하지 않습니다.",
                    this.getAlertOptions
                  )
                  .then((value) => {})
                  .catch((err) => {
                    console.error(err);
                  });
              }
            } else {
              this.btnDisabled = false;
              this.curTopicId = null;
            }
          } else {
            this.LoadYn = false;
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(
                utils.chkNull(res.data.error_msg, "관리자에게 문의하세요."),
                this.getAlertOptions
              )
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    drawTimeLineChart(id, param, range) {
      var data = [
        {
          x: param.x,
          y: param.y,
          name: param.name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      var layout = chartUtil.setTimeLayout(id, {
        datacnt: param.x.length,
        showxaxiscnt: 4,
        margin: {
          l: 70,
          r: 20,
          t: 20,
          b: 30,
          pad: 0,
        },
        showlegend: false,
      });
      if (range !== undefined && range !== null) {
        if (range.x !== undefined && range.x !== null) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (range.y !== undefined && range.y !== null) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      layout.height = 143;
      Plotly.newPlot(id, data, layout);
    },
    draw3dChart(id, param, range) {
      var data = [
        {
          x: param.x,
          y: param.y,
          z: param.z,
          name: param.name,
          opacity: 0.7,
          type: "scatter3d",
          mode: "markers",
          marker: {
            size: 1,
            color: "#ff7f0e",
          },
        },
      ];
      var layout = {
        scene: {
          xaxis: { title: "위도", color: "#b4b7bd" },
          yaxis: { title: "경도", color: "#b4b7bd" },
          zaxis: { title: "고도", color: "#b4b7bd" },
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
        },
        showlegend: false,
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
      };
      Plotly.newPlot(id, data, layout);
    },
    subRealtimeData(data) {
      if (data) {
        if (Object.keys(data).includes("data")) {
          console.log("RealTime Data subscribe!!");
          this.draw3dChart("dataChart1", { x: [], y: [], z: [], name: "3d" });
          this.drawTimeLineChart("dataChart2", {
            x: [],
            y: [],
            name: "latitude",
          });
          this.drawTimeLineChart("dataChart3", {
            x: [],
            y: [],
            name: "longitude",
          });
          this.drawTimeLineChart("dataChart4", {
            x: [],
            y: [],
            name: "altitude",
          });

          for (let i = 0; i < msg.data.length; i++) {
            let time = moment(msg.data[i][0]).format("YYYY-MM-DD HH:mm:ss.SSS");
            let lat = msg.data[i][1];
            let long = msg.data[i][2];
            let alt = Number(msg.data[i][3]);

            Plotly.extendTraces(
              "dataChart1",
              { x: [[lat]], y: [[long]], z: [[alt]] },
              [0],
              this.dataChartCnt
            );
            Plotly.extendTraces(
              "dataChart2",
              { x: [[time]], y: [[lat]] },
              [0],
              this.dataChartCnt
            );
            Plotly.extendTraces(
              "dataChart3",
              { x: [[time]], y: [[long]] },
              [0],
              this.dataChartCnt
            );
            Plotly.extendTraces(
              "dataChart4",
              { x: [[time]], y: [[alt]] },
              [0],
              this.dataChartCnt
            );

            this.sensorstate = msg.data[i][4];
            this.statedescription = this.description[this.sensorstate];
          }
        } else {
          // Subscribe 시도 시 미연결 상태이면
          // 먼저 연결
          setTimeout(() => {
            this.subRealtimeData(param);
          }, 500);
        }
      }
    },
    unSubRealtimeData() {
      console.log("RealTime Data unsubscribe..");
      this.getWebSocket.send(
        JSON.stringify({
          target: "offRabbitMQData",
          topic: this.curTopicId,
        })
      );
    },
    closeModal() {
      this.cmdRealtimeData("stop");
      this.$nextTick(() => {
        this.$bvModal.hide("gnssSensorDataChartModal");
      });
    },
  },
};
</script>

<style lang="scss">
#gnssSensorDataChartModal .modal-dialog {
  max-width: 1500px;
  & .chartarea {
    padding: 20px;
    & .card {
      padding: 0;
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #1f2327;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/GnssSensorDataChartModal.vue